import React from 'react'
import { Button, IconButton, Menu, MenuItem } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import { FormattedMessage } from 'react-intl'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import { NavLink } from 'react-router-dom'
import { formatRoute } from 'react-router-named-routes'
import { NamedRoutes } from '../../../../routes'
import { TableRowBackground } from '../../../../utils/colors'
import { useStyles } from './Styles'
import DeleteCompany from './DeleteCompany'
import EditCompanySubscription from './EditCompanySubscription'
import { AuthenticatedUserConsumer } from '../../../../AuthenticatedUserContext'

const CompanyMenu = ({ index, data, setData, setCount }) => {
  let classes = useStyles()
  const [anchorEl, setAnchorEl] = React.useState(null)
  const [viewUserMenu, setViewUserMenu] = React.useState(false)
  const open = Boolean(anchorEl)

  const handleClick = (event) => {
    setViewUserMenu(true)
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
    setViewUserMenu(false)
  }

  const StyledMenu = withStyles({
    paper: {
      border: `1px solid ${TableRowBackground}`
    }
  })((props) => (
    <Menu
      elevation={4}
      getContentAnchorEl={null}
      anchorOrigin={{
        vertical: 'center',
        horizontal: 'left'
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left'
      }}
      disableScrollLock
      {...props}
    />
  ))

  const [viewDeleteCompanyDialog, setViewDeleteCompanyDialog] = React.useState(false)
  const [openDeleteCompanyDialog, setOpenDeleteCompanyDialog] = React.useState(false)
  const handleDeleteCompanyDialog = () => {
    if (!openDeleteCompanyDialog) {
      setViewDeleteCompanyDialog(true)
    } else {
      setTimeout(() => setViewDeleteCompanyDialog(false), 500)
    }
    setOpenDeleteCompanyDialog(!openDeleteCompanyDialog)
  }

  const [viewEditSubscriptionDialog, setViewEditSubscriptionDialog] = React.useState(false)
  const [openEditSubscriptionDialog, setOpenEditSubscriptionDialog] = React.useState(false)
  const handleEditSubscriptionDialog = () => {
    if (!openEditSubscriptionDialog) {
      setViewEditSubscriptionDialog(true)
    } else {
      setTimeout(() => setViewEditSubscriptionDialog(false), 500)
    }
    setOpenEditSubscriptionDialog(!openEditSubscriptionDialog)
  }

  return (
    <AuthenticatedUserConsumer>
      {({ handleNotificationCall }) => (
        <div>
          <IconButton
            aria-label="more"
            aria-controls="long-menu"
            aria-haspopup="true"
            onClick={handleClick}
          >
            <MoreVertIcon/>
          </IconButton>
          {!!viewUserMenu &&
          <StyledMenu
            id="long-menu"
            anchorEl={anchorEl}
            keepMounted
            open={open}
            onClose={handleClose}
            className={classes.UserCustomMenu}
          >
            <MenuItem onClick={handleClose}>
              <NavLink to={formatRoute(NamedRoutes.workspace.company.users, { id: data[index].id })}>
                <FormattedMessage id='Companies.CompanyUsers'/>
              </NavLink>
            </MenuItem>
            <MenuItem onClick={handleClose}>
              <Button color="primary" onClick={handleEditSubscriptionDialog}>
                <FormattedMessage id='Companies.EditSubscription.MenuLabel'/>
              </Button>
            </MenuItem>
            {data[index]?.tax_id === null &&
            <MenuItem onClick={handleClose}>
              <Button color="primary" onClick={handleDeleteCompanyDialog}>
                <FormattedMessage id='UserMenu.deletePage'/>
              </Button>
            </MenuItem>
            }
          </StyledMenu>
          }
          <DeleteCompany
            index={index}
            data={data}
            setData={setData}
            setCount={setCount}
            handleNotificationCall={handleNotificationCall}
            handleDeleteCompanyDialog={handleDeleteCompanyDialog}
            viewDeleteCompanyDialog={viewDeleteCompanyDialog}
            openDeleteCompanyDialog={openDeleteCompanyDialog}
          />
          <EditCompanySubscription
            index={index}
            data={data}
            setData={setData}
            handleNotificationCall={handleNotificationCall}
            handleEditSubscriptionDialog={handleEditSubscriptionDialog}
            viewEditSubscriptionDialog={viewEditSubscriptionDialog}
            openEditSubscriptionDialog={openEditSubscriptionDialog}
          />
        </div>
      )}
    </AuthenticatedUserConsumer>
  )
}

export default CompanyMenu
